import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import {
  AbstractSecurityStorage,
  OidcSecurityService,
  provideAuth,
  StsConfigLoader,
} from 'angular-auth-oidc-client';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import {
  rootTranslateServiceConfig,
  translateHttpLoaderConfig,
  initializeLanguage,
  initializeMatomo,
  provideBimplusWebSdk,
  withEmbeddedValidation,
  OcpStorage,
  initializeAuth,
  initializeDebugTools,
  HTTP_UNAUTHORIZED_ERROR_DIALOG,
  MATOMO_TRACKER_CONFIG,
  VIEWER_BASE_URL,
  CONNECT_PORTAL_URL,
  initializeHostCommunication,
  MATOMO_SCRIPT_DEFAULTS,
  CONSENT_CONFIG,
  CONNECT_API_URL,
  UserStrategy,
  AuthorizationStrategy,
  AuthorizationService,
  OidcSecurityServiceStrategy,
} from 'shared';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import {
  ActionCardStrategy,
  UnauthorizedStrategy,
  ActionCardComponent,
  OCP_IMAGE_DEFAULTS,
} from 'ui';
import { authConfigFactory } from './data-access/auth/auth-config.factory';
import { provideUserDomain, UserFacade } from '@web-portal/domains/user/anti-corruption-layer';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: OidcSecurityServiceStrategy, useClass: OidcSecurityService },
    { provide: UserStrategy, useClass: UserFacade },
    { provide: AuthorizationStrategy, useExisting: AuthorizationService },
    {
      provide: ActionCardStrategy,
      useClass: UnauthorizedStrategy,
    },
    {
      provide: HTTP_UNAUTHORIZED_ERROR_DIALOG,
      useValue: ActionCardComponent,
    },
    provideUserDomain(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(),
    provideAuth({
      loader: {
        provide: StsConfigLoader,
        useFactory: authConfigFactory,
        deps: [HttpClient],
      },
    }),
    { provide: AbstractSecurityStorage, useClass: OcpStorage },
    provideTranslateService(rootTranslateServiceConfig),
    provideTranslateHttpLoader(translateHttpLoaderConfig),
    provideAppInitializer(initializeHostCommunication),
    provideAppInitializer(initializeAuth),
    provideAppInitializer(initializeDebugTools),
    provideAppInitializer(initializeLanguage),
    provideAppInitializer(initializeMatomo('Portal', environment.analyticsFlag)),
    {
      provide: OCP_IMAGE_DEFAULTS,
      useValue: { crossorigin: environment.useCrossOriginImagesByDefault ? 'anonymous' : null },
    },
    {
      provide: MATOMO_SCRIPT_DEFAULTS,
      useValue: { crossorigin: environment.useCrossOriginScriptsByDefault ? 'anonymous' : null },
    },
    {
      provide: MATOMO_TRACKER_CONFIG,
      useValue: {
        trackerUrl: environment.matomoTrackerUrl,
        siteId: environment.matomoSiteId,
        environment: environment.bimplus.environment,
      },
    },
    provideBimplusWebSdk(
      { environment: environment.bimplus.environment },
      withEmbeddedValidation()
    ),
    { provide: VIEWER_BASE_URL, useValue: environment.viewerBaseUrl },
    { provide: CONNECT_PORTAL_URL, useValue: environment.connectPortalUrl },
    { provide: CONNECT_API_URL, useValue: environment.connectApiUrl },
    { provide: CONSENT_CONFIG, useValue: environment.consent },
  ],
};
